import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Button, Checkbox, Icon, Input, Select } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import _ from 'lodash';

import {
  updateAssignUserData,
  checkAll,
  updateIsPageAccessible,
} from '../state/assignUsers/actions';
import { forceDirtyState } from '../../../state/dirtyTracking/actions';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { TrackedCheckbox } from 'Components';
import { SecurityPreferences } from 'Common/Security/SecurityPreferences';
import { PreferencesEnum as PrefEnum } from 'Common/Security/PreferencesEnum';
import { FieldEnum } from 'Common/FieldEnum';
import { groupNameOptions, subGroupNameOptions } from 'Common/Constants';

class AssignUserGridContainer extends Component {
  state = {
    filtered: [],
    expanded: [],
  };
  filterFunctionName = null;
  filterSubMenuGroup = null;

  onFilteredChange = filtered => this.setState({ filtered: filtered });
  render() {
    const { loading, assignUserData } = this.props;
    const sortedData = _.sortBy(assignUserData, ['LastName', 'FirstName']);

    return (
      <div className="assign-user-to-site">
        <Button
          className={'clear-filters-button'}
          content="Clear Filters"
          onClick={() => this.setState({ filtered: [], expanded: [] })}
        />
        <ReactTable
          loading={loading}
          defaultPageSize={15}
          showPageSizeOptions={false}
          minRows={15}
          expanded={this.state.expanded}
          data={sortedData}
          resizable={false}
          className="-striped -highlight" //modalGrid prevents padding at bottom
          defaultFilterMethod={caseInsensitiveFilter}
          onFilteredChange={this.onFilteredChange}
          filtered={this.state.filtered}
          onExpandedChange={(newExpanded, index, event) => {
            this.setState({ expanded: newExpanded });
          }}
          sortable={false}
          columns={[
            {
              expander: true,
              Header: '',
              width: 40,
              Expander: ({
                isExpanded,
                original: { AccessibleFunctions = [] },
              }) => {
                let props = {};

                if (isExpanded) {
                  props = { rotated: 'clockwise' };
                }

                return (
                  !!AccessibleFunctions.length && (
                    <Icon name="caret right" {...props} />
                  )
                );
              },
            },
            {
              Header: 'Username',
              accessor: 'UserName',
              filterable: true,
            },
            {
              Header: 'First Name',
              accessor: 'FirstName',
              filterable: true,
            },
            {
              Header: 'Last Name',
              accessor: 'LastName',
              filterable: true,
            },
            {
              Header: 'User Role',
              accessor: 'Role',
              filterable: true,
            },
            {
              Header: currentRows => {
                return (
                  <span>
                    <SecurityPreferences scope={PrefEnum.AssignUsers}>
                      {disabled => {
                        return (
                          <div>
                            <div>Access</div>
                            <Checkbox
                              checked={this.props.checkAllChecked}
                              onChange={(e, data) => {
                                this.props.forceDirtyState();
                                this.props.checkAll(
                                  data.checked,
                                  currentRows.data,
                                  FieldEnum.Allowed
                                );
                              }}
                              disabled={
                                disabled ||
                                !(assignUserData && assignUserData.length > 0)
                              }
                            />
                          </div>
                        );
                      }}
                    </SecurityPreferences>
                  </span>
                );
              },
              accessor: FieldEnum.Allowed,
              maxWidth: 120,
              sortable: true,
              Cell: ({ original }) => {
                const initialValue = _.find(this.props.initialAssignUserData, {
                  username: original.UserName,
                }).initialValue;
                return (
                  <SecurityPreferences scope={PrefEnum.AssignUsers}>
                    {disabled => {
                      return (
                        <div style={{ textAlign: 'center' }}>
                          <TrackedCheckbox
                            initialValue={initialValue}
                            checked={original[FieldEnum.Allowed]}
                            disabled={disabled}
                            onChange={() => {
                              this.props.updateAssignUserData(
                                original,
                                FieldEnum.Allowed
                              );
                            }}
                          />
                        </div>
                      );
                    }}
                  </SecurityPreferences>
                );
              },
            },
          ]}
          SubComponent={({
            original: { AccessibleFunctions, UserName, Allowed },
          }) => {
            if (!!AccessibleFunctions.length) {
              const initialAccessibleFunctions = _.find(
                this.props.initialAssignUserData,
                {
                  username: UserName,
                }
              ).AccessibleFunctions;
              return (
                <ReactTable
                  loading={loading}
                  filterable
                  defaultPageSize={AccessibleFunctions.length}
                  showPageSizeOptions={false}
                  defaultFilterMethod={(filter, row) =>
                    String(row[filter.AccessInfoId]) === filter.value
                  }
                  className="-striped -highlight modalGrid no-hover nested--react-table"
                  data={AccessibleFunctions}
                  resizable={false}
                  sortable={false}
                  showPagination={false}
                  columns={[
                    {
                      Header: 'Read Only Menu Access',
                      columns: [
                        {
                          Header: 'Group Name',
                          accessor: 'GroupName',
                          id: 'groupName',
                          filterMethod: (filter, rows) => {
                            if (filter.value === 0) return rows;
                            return caseInsensitiveFilter(filter, rows);
                          },
                          Filter: ({ filter, onChange }) => {
                            return (
                              <Select
                                onChange={(event, data) => {
                                  event.preventDefault();
                                  onChange(data.value);
                                  this.filterFunctionName = data.value;
                                }}
                                fluid
                                placeholder="Filter by GroupName"
                                options={groupNameOptions}
                              />
                            );
                          },
                        },
                        /**
                         * SubGroup Name Column
                         */
                        {
                          Header: 'SubGroup Name',
                          accessor: 'SubGroupName',
                          id: 'subGroupName',
                          filterMethod: (filter, rows) => {
                            if (filter.value === 0) return rows;
                            return caseInsensitiveFilter(filter, rows);
                          },
                          Filter: ({ filter, onChange }) => {
                            return (
                              <Select
                                onChange={(event, data) => {
                                  onChange(data.value);
                                  this.filterSubMenuGroup = data.value;
                                }}
                                fluid
                                placeholder="Filter by SubmenuGroup"
                                options={subGroupNameOptions}
                              />
                            );
                          },
                        },
                        {
                          Header: 'Function Name',
                          accessor: 'FunctionName',
                          id: 'functionName',
                          filterMethod: (filter, rows) =>
                            caseInsensitiveFilter(filter, rows),
                          Filter: ({ filter, onChange }) => {
                            return (
                              <Input
                                onChange={(event, data) => {
                                  event.preventDefault();
                                  onChange(data.value);
                                  this.filterFunctionName = data.value;
                                }}
                                fluid
                                placeholder="Filter by FunctionName"
                              />
                            );
                          },
                        },
                        /**
                         * Access Column
                         */
                        {
                          Header: '',
                          id: 'IsPageAccessible',
                          accessor: 'IsPageAccessible',
                          filterMethod: (filter, rows) => false,
                          filterable: false,
                          Cell: ({ original, index }) => {
                            const initialValue = _.find(
                              initialAccessibleFunctions,
                              {
                                AccessInfoId: original.AccessInfoId,
                              }
                            )[FieldEnum.IsPageAccessible];
                            return (
                              <div style={{ textAlign: 'center' }}>
                                <TrackedCheckbox
                                  initialValue={initialValue}
                                  checked={original[FieldEnum.IsPageAccessible]}
                                  disabled={!Allowed}
                                  onChange={() => {
                                    this.props.updateIsPageAccessible(
                                      original,
                                      FieldEnum.IsPageAccessible,
                                      UserName,
                                      index
                                    );
                                  }}
                                />
                              </div>
                            );
                          },
                          maxWidth: 100,
                        },
                      ],
                    },
                  ]}
                />
              );
            }
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ SiteSetupState: { assignUsers } }) => {
  return {
    initialAssignUserData: assignUsers.initialData,
    assignUserData: assignUsers.data,
    checkAllChecked: assignUsers.checkAllChecked,
  };
};
const mapDispatchToProps = {
  updateAssignUserData,
  checkAll,
  forceDirtyState,
  updateIsPageAccessible,
};

export const AssignUserGrid = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AssignUserGridContainer)
);



// WEBPACK FOOTER //
// ./src/pages/sitesetup/components/AssignUserGrid.js